<template>
  <div class="l-block__detail">
    <TitleSub level="h3">
      <span class="title">執筆する</span>
      <span class="description">
        見出し作成した記事を執筆しましょう。
      </span>
    </TitleSub>

    <div>
      <TitleSub level="h4">
        <span class="title">「進行中」タスクのキーワード</span>
        <Tooltip size="sm">
          新規コンテンツ作成タスクのステータスが「進行中」のものが表示されます。執筆が完了したら、対象のタスクに対して「タスクを完了する」ボタンをクリックしてタスクを完了してください。
        </Tooltip>
      </TitleSub>

      <div class="c-table">
        <div class="c-table__header">
          <div class="items">
            <div class="item_header_keyword">
              キーワード（<span :class="{ active: tasksCount > 0 }"
                >{{ tasksCount }}件</span
              >）
            </div>
            <div class="item_header_name">担当者</div>
            <div class="item_header_date">完了予定日</div>
            <div class="item_header_button"></div>
          </div>
        </div>

        <div class="c-table__body">
          <div v-if="isLoading">
            <div class="items">
              <Loading variant="inline" />
            </div>
          </div>

          <template v-else-if="tasksCount === 0">
            <Error variant="inline">
              <template slot="title">
                タスクがありません。
              </template>
              <p>
                タスクリスト >
                新規コンテンツ作成タスクのステータスを「進行中」に変更すると表示されます。
              </p>
            </Error>
          </template>

          <template v-else>
            <ListItemNewContentWriting
              v-for="item in sortedItems"
              :key="item.id"
              :item="item"
              @taskCompleteModalOpen="openModalTaskComplete"
            />
          </template>
        </div>
      </div>
    </div>
    <ModalFormTaskComplete
      v-if="modal.isActive"
      :project="project"
      :item="modal.item"
      @close="closeModalTaskComplete"
      @openModalRegisterObservationKeyword="openModalRegisterObservationKeyword"
      @completeTask="completeTask"
    />
    <ModalFormRegisterObservationKeyword
      v-if="modalObservationKeyword.isActive"
      :project="project"
      :item="modalObservationKeyword.item"
      @close="closeModalObservationKeyword"
    />
  </div>
</template>

<script>
import TitleSub from '@/components/TitleSub';
import Tooltip from '@/components/Tooltip';
import Loading from '@/components/Loading';
import Error from '@/components/Error';
import ListItemNewContentWriting from '@/components/dashboard/ListItemNewContentWriting';
import ModalFormTaskComplete from '@/components/dashboard/ModalFormTaskComplete';
import ModalFormRegisterObservationKeyword from '@/components/dashboard/ModalFormRegisterObservationKeyword';
import utils from '@/utils';

export default {
  props: {
    project: {
      type: Object,
      required: true
    },
    tasks: {
      type: Array,
      required: true
    },
    tasksCount: {
      type: Number,
      required: true
    },
    isLoading: {
      type: Boolean,
      required: true
    }
  },

  components: {
    TitleSub,
    Tooltip,
    Loading,
    Error,
    ListItemNewContentWriting,
    ModalFormTaskComplete,
    ModalFormRegisterObservationKeyword
  },

  data() {
    return {
      modal: {
        item: {},
        isActive: false
      },
      modalObservationKeyword: {
        item: {},
        isActive: false
      },
      params: {
        sort: {
          name: 'executionDate',
          orderby: 'asc',
          type: 'date'
        }
      }
    };
  },

  methods: {
    completeTask(task) {
      this.$emit('completeTask', task);
    },
    openModalTaskComplete(item) {
      this.modal.isActive = true;
      this.modal.item = item;
    },
    closeModalTaskComplete() {
      this.modal.item = {};
      this.modal.isActive = false;
    },
    openModalRegisterObservationKeyword(item) {
      this.modalObservationKeyword.isActive = true;
      this.modalObservationKeyword.item = item;
    },
    closeModalObservationKeyword() {
      this.modalObservationKeyword.isActive = false;
      this.modalObservationKeyword.item = {};
    }
  },

  computed: {
    sortedItems() {
      return utils.sort(
        this.tasks,
        this.params.sort.type,
        this.params.sort.orderby,
        this.params.sort.name
      );
    }
  }
};
</script>
